import { render, staticRenderFns } from "./ClientLaunchings.vue?vue&type=template&id=80b094d2"
import script from "./ClientLaunchings.vue?vue&type=script&lang=js"
export * from "./ClientLaunchings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports